import { NgModule, AfterViewInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from 'angular-framework-client-components/app.component';
import { AppModule } from './app.module';
import { BrowserTransferStateModule } from 'angular-engine/modules/transfer-state/browser-transfer-state.module';
import { BrowserPrebootModule, EventReplayer } from 'preboot/browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { REQUEST, RESPONSE, APP_SETTINGS, DEVICE_INFO, NAVIGATION_LINKS, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2Vdgm } from 'angular-engine/engine/providers/Angulartics2Vdgm';
import { AppInternalSettings } from 'angular-framework-client-components/model/app-settings';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { appendFile } from 'fs';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { NoOpStorageService } from 'angular-engine/engine/service/user/noop-storage-service';

declare var Hammer:any;

var md = require('mobile-detect');
var bowser = require('bowser');

export class CustomHammerConfig extends HammerGestureConfig  {

  overrides = <any>{
      'swipe': {direction: Hammer.DIRECTION_HORIZONTAL}
  }

  buildHammer(element: HTMLElement) {
    const mc = new Hammer(element, {
      touchAction: 'pan-y',
      cssProps: {
        userSelect: true
      },
          inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput,
          recognizers: [
            [Hammer.Swipe, {
              direction: Hammer.DIRECTION_HORIZONTAL
            }]
          ]
    });
    return mc;
  }
}

var appProviders =  [ //NOOP Response and Request tokens used by server for injection purposes
  {
    provide: RESPONSE,
    useValue: {}
  },
  {
    provide: REQUEST,
    useValue: window.location
  },
  {
    provide: DEVICE_INFO,
    useFactory: setDevice
  },
  {
    provide: NAVIGATION_LINKS,
    useValue: []
  },
  {
    provide: APP_SETTINGS,
    useValue: AppInternalSettings.settings
  },
  {
    provide: HAMMER_GESTURE_CONFIG,
    useClass: AppInternalSettings.settings["USE_HAMMERJS"] ? CustomHammerConfig : HammerGestureConfig
  },
  {
    provide: OAuthStorage,
    useValue: new NoOpStorageService()
  }

]

// if (AppInternalSettings.settings["USE_HAMMERJS"]){
//   appProviders.splice(appProviders.findIndex(matchesEl), 1);
//   appProviders.push({
//     provide: HAMMER_GESTURE_CONFIG,
//     useClass: CustomHammerConfig
//   })
// };

function matchesEl(el) {
  return el.provide == HAMMER_GESTURE_CONFIG;
}

export function setDevice() : DeviceInfo{
  const deviceHandler = new md(window.navigator.userAgent);
  let deviceInfo : DeviceInfo = {
    isDesktop: true,
    isMobile: false,
    isPhone: false,
    isTablet: false,
    userAgent: '',
    device: 'desktop'
  };

  if (deviceHandler.tablet() || deviceHandler.phone()){
    deviceInfo.isDesktop = false;
    deviceInfo.isMobile = true;
    if (deviceHandler.tablet()){
      deviceInfo.isTablet = true;
      deviceInfo.device = "tablet";
    }
    else{
      deviceInfo.isPhone = true;
      deviceInfo.device = "phone";
    }
  }
  deviceInfo.userAgent = bowser.name;

  return deviceInfo;
}

@NgModule({
	bootstrap: [ AppComponent ],
	imports: [
    BrowserModule.withServerTransition({
      appId: 'my-app-id'
    }),
    BrowserTransferStateModule,
    AppModule,
    BrowserAnimationsModule,
    //BrowserPrebootModule.replayEvents(),
    Angulartics2Module.forRoot([ Angulartics2Vdgm ], {
      pageTracking: {
        autoTrackVirtualPages: false
      },})
  ],
  providers: appProviders
})
export class BrowserAppModule {
}



// WEBPACK FOOTER //
// ./src/app/browser-app.module.ts